import { BrowserRouter as Router, Route, Navigate, Routes, Outlet, useLocation, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageContext, LanguageProvider } from "@lib/i18n/LanguageProvider";
import { useContext } from "react";
import { getStorageLang } from "@stores/Language";
import Layout from "./routes/layout/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PageNotFound from "./routes/pages/PageNotFound";

import RequestTrackingScreen from "./routes/pages/customer/RequestTrackingScreen";
import DeveloperScreen from "./routes/pages/DeveloperScreen";
import RequestCreationForm from "./routes/pages/customer/RequestCreationForm";

import Homepage from "./routes/pages/landing/Homepage";
import RequestPage from "./routes/pages/customer/RequestPage";
import ChatAI from "./routes/pages/ChatAI";

function PublicRoutes() {
  return <Outlet />;
}

function ProtectedRoutes() {
  return (
    // <LoginCheck>
    //   <Outlet />
    // </LoginCheck>
    <Outlet />
  );
}

function App() {
  const storedLang = getStorageLang() || "tr-TR"; // localStorage'dan dil al, yoksa varsayılan 'tr-TR'

  return (
    <Router>
      <LanguageProvider>
        <HelmetProvider>
          <Routes>
            {/* Boş path durumunda kullanıcının diline yönlendirme yap */}
            <Route path="/" element={<Navigate to={`/${storedLang}/Request`} replace />} />
            <Route path="dev" element={<DeveloperScreen />} />
            {/* Dil parametresi olan rotalar */}
            <Route path="/:lang/*" element={<Layout />}>
              <Route path="Track/:id/:guid" element={<RequestTrackingScreen />} />
              <Route path="Form/:id/:guid" element={<RequestCreationForm />} />

              <Route path="Request" element={<RequestPage />} />

              <Route path="Homepage" element={<Homepage />} />

              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="ChatAI" element={<ChatAI />} />
          </Routes>

          <ToastContainer position="top-right" autoClose={3000} />
        </HelmetProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
